import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useHelpFaqsQuery.ts
var r = (r = {}) => t({
	queryKey: e.faqs(r),
	queryFn: () => n.listFaqs(r)
});
//#endregion
export { r as useHelpFaqsQuery };
